import { render } from "./trust-data-external-examiner.html?vue&type=template&id=218889c0&scoped=true&ts=true&external"
import script from "./trust-data-external-examiner.ts?vue&type=script&lang=ts&external"
export * from "./trust-data-external-examiner.ts?vue&type=script&lang=ts&external"

import "./trust-data-external-examiner.scss?vue&type=style&index=0&id=218889c0&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-218889c0"]])

export default __exports__